import { render, staticRenderFns } from "./hot-comments-list.vue?vue&type=template&id=0e6526d4&scoped=true&"
import script from "./hot-comments-list.vue?vue&type=script&lang=js&"
export * from "./hot-comments-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6526d4",
  null
  
)

export default component.exports